import React, { useState } from 'react';

import { newUserMenuButton } from '@aline/common';
import { AlineButton, UserProfileDialog } from 'src/components';
import { useAccessGuard } from 'src/components/auth';
import { WhitePlusIcon } from 'src/components/icons/WhitePlusIcon';
import { Apollo } from 'src/gql/generated';

export function NewUsersMenu(): JSX.Element {
  const [newUserDialogOpen, setNewUserDialogOpen] = useState<boolean>(false);
  const handleClickAddUser = useAccessGuard({
    callback: () => setNewUserDialogOpen(true),
    minRole: Apollo.OrgRole.Admin,
  });

  return (
    <>
      <AlineButton
        color="primary"
        data-cy={newUserMenuButton}
        endIcon={<WhitePlusIcon />}
        variant="contained"
        onClick={handleClickAddUser}
      >
        New User
      </AlineButton>
      <UserProfileDialog open={newUserDialogOpen} setOpen={setNewUserDialogOpen} />
    </>
  );
}
